/// <reference path="PackageInfo.ts" />
namespace SP {

    export interface PackageTransferInfo {
        match: boolean;
        fromLocationKey: string;
        toLocationKey: string;
        fromLocationName: string;
        toLocationName: string;
        orderNo: string;
        package: PackageInfo;
        itemInfos: { [packageLineId: string]: ItemInfo }
    }
}
